// extracted by mini-css-extract-plugin
export var centerList = "_j5-6";
export var centerLoc = "_j5-a";
export var centerName = "_j5-9";
export var centerOptionBody = "_j5-8";
export var centerRow = "_j5-7";
export var centerStatus = "_j5-b";
export var empty = "_j5-5";
export var externalIcon = "_j5-c";
export var fieldHeader = "_j5-2";
export var fieldHelp = "_j5-4";
export var fieldLabel = "_j5-3";
export var panel = "_j5-0";
export var removeBtn = "_j5-d";
export var section = "_j5-1";